import Input from 'components/input/input';
import Select from 'components/select/select';
import { INTELLIO_SPECIALTIES } from 'config/doctor';

const ViewComponent = ({
  user,
  onChange,
  onSpecialtyChange,
  validation,
  validationText,
}) => {
  return (
    <>
      <h4 className="midlightgrey f-small fw5 ttu">General info</h4>
      <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column">
        <div className="w-100 flex flex-row items-start justify-between margin-between">
          <div className="w-100">
            <div className="w-100 flex justify-between margin-between">
              <Input
                name="firstName"
                valid={validation.firstName}
                validationText={validationText.firstName}
                label="First Name*"
                value={user.firstName}
                onChange={onChange}
              />
              <Input
                name="lastName"
                valid={validation.lastName}
                validationText={validationText.lastName}
                label="Last Name*"
                value={user.lastName}
                onChange={onChange}
              />
            </div>
            <div className="w-100 flex justify-between margin-between">
              <div className="w-50">
                <Input
                  name="email"
                  valid={validation.email}
                  validationText={validationText.email}
                  label="Email*"
                  value={user.email}
                  onChange={onChange}
                />
              </div>
              <div className="w-50">
                <Select
                  isMulti={false}
                  valid={validation.specialty}
                  validationText={validationText.specialty}
                  value={INTELLIO_SPECIALTIES.find(
                    (s) => s.value === user.specialty,
                  )}
                  label="Select speciality*"
                  options={INTELLIO_SPECIALTIES}
                  className="single-select"
                  onChange={onSpecialtyChange}
                />
              </div>
            </div>
            <div className="w-100 flex justify-between margin-between">
              <div className="w-50">
                <Input
                  name="rpps"
                  valid={validation.rpps}
                  validationText={validationText.rpps}
                  label="RPPS*"
                  value={user.rpps}
                  onChange={onChange}
                />
              </div>
              <div className="w-50">
                <Input
                  name="finesId"
                  valid={validation.finesId}
                  validationText={validationText.finesId}
                  label="FINESS*"
                  value={user.finesId}
                  onChange={onChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewComponent;
